import { render, staticRenderFns } from "./PropertySelectRentStatus.vue?vue&type=template&id=484d60df"
import script from "./PropertySelectRentStatus.vue?vue&type=script&lang=js"
export * from "./PropertySelectRentStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports